export default __webpack_public_path__ + "f51c4d5629dbb7dd6274bfb2fc5a1202.svg";